import {Component, Input, OnInit} from '@angular/core';
import {CommonModule, NgIf} from "@angular/common";
import {Button, ButtonModule} from "primeng/button";
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {SipoService} from "../../services/SipoService";
import {TranslatePipe} from "@ngx-translate/core";
import {ActivatedRoute} from "@angular/router";
import {ProgressSpinnerModule} from "primeng/progressspinner";

@Component({
    selector: 'app-sign-process-state',
    standalone: true,
    imports: [
        ButtonModule,
        CommonModule,
        TranslatePipe,
        ProgressSpinnerModule
    ],
    templateUrl: './sign-process-state.component.html',
    styleUrl: './sign-process-state.component.scss'
})
export class SignProcessStateComponent implements OnInit {

    @Input() selfSignUrl!: string;



    @Input() toastInfo: {
        isOpen: boolean;
        state: string;
        isSelfSign: boolean;
    } = {
        isOpen: false,
        state: '',
        isSelfSign: false
    }

    process!: string;
    subitemid!: string;

    code!: string | null;
    signDirectlySelf: boolean = true;

    constructor(private ref: DynamicDialogRef,
                private sipoService: SipoService,
                private route: ActivatedRoute
    ) {
    }

    signDocument() {
        const a = document.createElement('a');
        a.href = this.selfSignUrl;
        a.target = '_self'; // oder '_blank' für neuen Tab
        a.click();
    }

    ngOnInit() {

        const parts = this.selfSignUrl.split('/');

        this.route.queryParams.subscribe(params => {
            this.code = params['code'] || null;
        })

        this.process = parts[4];    // "415819e3-5a65-43b7-a387-d70d517532d5"
        this.subitemid = parts[5];

        // this.sipoService.postSignBasic(this.process, this.subitemid, "basic").subscribe({
        //     next: value => {
        //         console.log("Successfully logged in", value);
        //     },
        //     error: err => {
        //         console.log(err);
        //     }
        // });


        // this.sipoService.postSignBasicBlob(this.process, this.subitemid, "basic").subscribe(blob => {
        //     const url = window.URL.createObjectURL(blob);
        //     const a = document.createElement('a');
        //     a.href = url;
        //     a.download = 'signing-document.pdf';
        //     a.click();
        //     window.URL.revokeObjectURL(url);
        // });

    }

    signNow(param
            :
            any
    ) {


        //console.log(param)
    }

    closeRef() {
        this.ref.close();
    }

    protected readonly console = console;
}
